<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="headline">
        <v-flex shrink>
          Instaplays
        </v-flex>
        <v-flex class="text-sm-left text-xs-right pl-2">
          <v-item-group multiple v-model="filters">
            <v-item
                v-for="filter in filterOptions"
                :key="filter.name"
                :value="filter.name"
            >
              <v-chip
                  :color="`${colorOf(filter.name)} lighten-1`"
                  :text-color="active ? 'white' : '' "
                  :outline="!active"
                  slot-scope="{ active, toggle }"
                  @click="toggle"
              >
                {{ filter.name }}
              </v-chip>
            </v-item>
          </v-item-group>
        </v-flex>
        <v-flex class="text-sm-right text-xs-center">
          <v-layout align-center class="d-inline-flex">
            <v-btn icon outline small round @click="$refs.calendar.prev()">
              <v-icon>
                keyboard_arrow_left
              </v-icon>
            </v-btn>
            <span class="d-inline-block">
              <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                      v-on="on"
                      round
                      depressed
                  >
                    {{monthYearDate}}
                  </v-btn>
                </template>
                <v-date-picker
                    v-model="date"
                    type="month"
                    color="primary"
                    no-title
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </span>
            <v-btn icon outline small round @click="$refs.calendar.next()">
              <v-icon>
                keyboard_arrow_right
              </v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-divider/>
      <v-layout>
        <v-flex>
          <v-sheet height="550">
            <v-calendar
                v-model="date"
                ref="calendar"
                color="primary"
            >
              <template v-slot:day="{ date }">
                <template v-for="event in eventsMap[date]">
                  <v-menu
                      :key="event.title"
                      v-model="event.open"
                      full-width
                      offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <div
                          v-if="!event.time"
                          v-ripple
                          class="my-event"
                          :class="colorOf(event.title)"
                          v-on="on"
                      >
                        {{event.title}}:
                        <span class="font-weight-bold">
                          {{ event.num }}
                        </span>
                      </div>
                    </template>
                    <v-card
                        max-width="350px"
                        min-width="325px"
                        flat
                    >
                      <v-toolbar
                          :color="`${colorOf(event.title)} lighten-1`"
                          dark flat
                      >
                        <v-toolbar-title class="text-capitalize" v-html="event.title"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text class="pb-0">
                        These players {{event.title}} <b>{{event.num}}</b> instaplays on <b>{{event.date | toDateStr}}</b>
                      </v-card-text>
                      <v-card-text class="px-0" primary-title>
                        <v-list>
                          <template v-for="(player, index) in event.users">
                            <v-list-tile :key="index" avatar
                                         @click="$router.push(`/admin/instaplays/${event.title}/${event.date}/${player.id}`,)">
                              <v-list-tile-avatar>
                                <img :src="thumbs[player.id]" v-if="thumbs[player.id]">
                                <v-icon v-else class="black--text accent">person</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title v-html="player.id" style="width: auto"></v-list-tile-title>
                              </v-list-tile-content>

                              <v-list-tile-action>
                                <v-chip>
                                  {{player.num}}
                                </v-chip>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-card-text>
<!--                      <v-card-actions>-->
<!--                        <v-spacer/>-->
<!--                        <v-btn-->
<!--                            flat-->
<!--                            color="secondary"-->
<!--                        >-->
<!--                          view all-->
<!--                        </v-btn>-->
<!--                      </v-card-actions>-->
                    </v-card>
                  </v-menu>
                </template>
              </template>
            </v-calendar>
          </v-sheet>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "InstaplaysAdmin",
        data: () => ({
            menu: false,
            dateModel: new Date().toISOString().substr(0, 10),
            filterOptions: [
                { name: 'played' },
                { name: 'published' },
            ],
            filters: ['played', 'published'],
            events: [
                {
                    title: 'played',
                    num: 1,
                    users: [
                        {
                            id: 'shahram@scorebook.live',
                            num: 1
                        }
                    ],
                    date: '2019-09-04',
                    open: false
                },
                {
                    title: 'published',
                    num: 4,
                    users: [
                        {
                            id: 'diana@un.gov',
                            num: 2
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 2
                        }
                    ],
                    date: '2019-08-31',
                    open: false
                },
                {
                    title: 'played',
                    num: 10,
                    users: [
                        {
                            id: 'bruce@gotham.city',
                            num: 4
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 3
                        },
                        {
                            id: 'diana@un.gov',
                            num: 3
                        }
                    ],
                    date: '2019-09-10',
                    open: false
                },
                {
                    title: 'played',
                    num: 2,
                    users: [
                        {
                            id: 'diana@un.gov',
                            num: 2
                        }
                    ],
                    date: '2019-09-07',
                    open: false
                },
                {
                    title: 'published',
                    num: 15,
                    users: [
                        {
                            id: 'bruce@gotham.city',
                            num: 10
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 5
                        }
                    ],
                    date: '2019-09-04',
                    open: false
                },
                {
                    title: 'published',
                    num: 3,
                    users: [
                        {
                            id: 'bruce@gotham.city',
                            num: 1
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 2
                        }
                    ],
                    date: '2019-09-10',
                    open: false
                },
                {
                    title: 'played',
                    num: 20,
                    users: [
                        {
                            id: 'bruce@gotham.city',
                            num: 3
                        },
                        {
                            id: 'diana@un.gov',
                            num: 15
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 2
                        }
                    ],
                    date: '2019-09-21',
                    open: false
                },
                {
                    title: 'published',
                    num: 11,
                    users: [
                        {
                            id: 'bruce@gotham.city',
                            num: 3
                        },
                        {
                            id: 'shahram@scorebook.live',
                            num: 5
                        },
                        {
                            id: 'diana@un.gov',
                            num: 3
                        }
                    ],
                    date: '2019-09-21',
                    open: false
                }
            ]
        }),
        computed: {
            date: {
                set(date) {
                    this.dateModel = date.substr(0, 7) + '-01'
                },
                get() {
                    return this.dateModel
                }
            },
            monthYearDate() {
                let date = this.dateModel.split('-')
                return new Date(parseInt(date[0]), parseInt(date[1])).toUTCString().substr(8, 9)
            },
            filteredEvents() {
                return this.events.filter(e => this.filters.includes(e.title))
            },
            eventsMap() {
                const map = {}
                this.filteredEvents.forEach(e => (map[e.date] = map[e.date] || []).push(e))
                return map
            },
            ...mapState('thumbnails', ['thumbs'])
        },
        methods: {
            open(event) {
                alert(event.title)
            },
            colorOf(type) {
                return type === 'played' ? 'deep-purple' : 'deep-orange'
            }
        }
    }
</script>

<style scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 4px;
    color: #ffffff;
    width: 100%;
    font-size: 12px;
    padding: 4px;
    cursor: pointer;
    margin: 2px 0;
  }
</style>
